<template>
  <el-dialog :visible.sync="dialogVisible" width="760px">
    <div>
      <div class="box-content-head">
        <p class="font16 colorfff" style="font-size:16px">欢迎使用匿名识别</p>
        <p class="font12 colorfff" style="font-size:12px">将追踪代码粘贴到您的网站上，即可识别出匿名访客背后的企业，让您与客户更进一步！</p>
        <!-- <p class="font14 colorfff">让您与客户更进一步！</p> -->
      </div>
      <div class="box-content">
        <p class="a1">让我们开始吧!</p>

        <div class="steps a2"><div class="b1">01</div> 为了让「匿名识别」能捕获您的网站访问者的信息，您需要将追踪代码放入页面的Html Body标签中</div>

        <div style="padding-left:34px">
          <div class="copyarea" id="copyText">{{content}}</div>
        </div>
        
        <div style="padding-left: 34px;">
          <div class="fixedClass">
            <a class="color3987EA" href="/zxk/junbros/codeExplain" style="color: #5088FF;font-size:14px">查看安装说明</a>
            <span class="btn" @click="clickCopy">复制</span>
          </div>
        </div>



        <div class="steps a2"><div class="b1">02</div> <span>添加代码后，一键检测代码是否安装成功.安装成功后，您将看到奇妙的事情，发现网站流量背后的秘密！</span></div>
        <div style="padding-left: 34px;" class="h1">
          <el-input placeholder="https://www.71360.com/" v-model="TestmainUrl">
            <!-- <span slot="append" style="" @click="clickCheck">点击检测</span> -->
             <el-button  type="primary" slot="append" @click="clickCheck" style="font-size: 14px;    height: 36px;">点击检测</el-button>
          </el-input>

        </div>
        <div style="padding-left: 18px;">
          <div v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-text="检测过程需要一点时间，请待心等待！"></div>
        </div>

        

      </div>
      <ul class="intro">
        <p class="a1">如何排除故障？</p>
        <li style="margin-top:6px">1.至少等待1天，以查看系统是否已收集了访客数据，如果您的网站流量较低（日均IP1000以内），这点尤其重要。</li>
        <li>2.检查并确保提供给您的追踪代码已粘贴到有流量的网页中。</li>
        <li>3.检查并确保代码已放入页面的HTML BODY标签中。</li>
      </ul>
    </div>
  </el-dialog>
</template>
<script>
import { checkMainUrl } from '../api/newClueApi'

export default {
  data () {
    return {
      dialogVisible: false,
      textarea: 'hello',
      TestmainUrl: '',
      loading: false,
      dialogShow: true
    }
  },
  props: {
    content: {
      type: String,
      default: ''
    },
    secondShow: {
      type: Number,
      default: 0
    }
  },
  mounted () {
  },
  methods: {
    clickClose () {
      this.dialogVisible = false
    },
    handleShow () {
      this.dialogVisible = true
    },
    clickCopy () {
      var strs0 = document.getElementById('copyText').innerText
      var textBox = document.createElement('input')
      textBox.value = strs0
      document.body.appendChild(textBox)
      textBox.select()
      document.execCommand('Copy')
      textBox.className = 'textBox'
      textBox.style.display = 'none'
      // this.$message.success('复制成功')
        this.$message({
          type: 'success',
          message: '复制成功',
          customClass: 'success-aa1'
        });

    },
    clickCheck () {
      var reg = '^((https|http|ftp|rtsp|mms)?://)'
      var re = new RegExp(reg)
      if (!re.test(this.TestmainUrl)) {
        this.$message({
          type: 'error',
          message: '请输入含http://或https://的网址',
          customClass: 'error-aa1'
        });
        return
      }
      this.loading = true
      checkMainUrl({ mainUrl: this.TestmainUrl }).then(res => {
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style>
.success-aa1{
  background: #F6FFF6;
  border: 1px solid #CAEFDC;
}
.error-aa1 .el-message__content{
   color: #FF0000 !important;
}
</style>
<style lang="scss" scoped>
.copyarea {
  background: rgba(187, 190, 202, 0.16);
  width: 100%;
  min-height: 120px;
  border-radius: 5px;
  padding: 15px;
  white-space: pre-line;
  font-size: 13px;
  font-weight: 400;
  color: #555555;
  line-height: 18px;
}
/deep/ .el-dialog__header {
  display: none;
}
/deep/ .el-dialog__body {
  padding: 0px;
  overflow-y: auto;
  background-color: rgba(255, 255, 255, 0)

}
/deep/ .el-input-group__append {
  background: #3987ea;
  color: #fff;
  cursor: pointer;
  > span {
    color: #fff;
  }
}
.box-content-head {
  position: relative;
  padding: 24px;
  height: 92px;
  background: -webkit-linear-gradient(
    0deg,
    rgba(39, 94, 223, 1) 0%,
    rgba(76, 177, 245, 1) 100%
  );
  background: -moz-linear-gradient(
    90deg,
    rgba(39, 94, 223, 1) 0%,
    rgba(76, 177, 245, 1) 100%
  );
  background: linear-gradient(
    90deg,
    rgba(39, 94, 223, 1) 0%,
    rgba(76, 177, 245, 1) 100%
  );
  box-sizing: border-box;
  border-radius: 10px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  > p {
    margin-bottom: 4px;
  }
}
.box-content {
  border-top: none;
  border-bottom: none;
  padding: 16px 24px;
  background: #fff;
  padding-bottom: 40px;
  .a1{
    font-size: 14px;
    font-weight: 600;
    color: #666666;
    line-height: 20px;
  }
  .a2{
    display: flex;
    align-items: center;
        font-size: 13px;
    font-weight: 400;
    color: #555555;
    line-height: 18px;
    .b1{
      width: 24px;
      height: 24px;
      background: #5088FF;
      border-radius: 2px;
      margin-right: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 20px;
    }
  }
  * {
    font-size: 13px;
    color: #555555;
  }
  .steps {
    margin: 25px 0px 17px 0;
  }
}
.intro {
  background: #F4F5F7;
  padding: 16px 24px;
  border-radius: 10px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  padding-bottom: 39px;
  p,
  li {
    font-size: 12px;
    // margin-bottom: 10px;
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    line-height: 22px;
  }
  .a1{
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 20px;
  }
}
.colorfff {
  color: #fff;
}
.font16 {
  font-size: 16px;
}
.font14 {
  font-size: 14px;
}
.color3987EA {
  color: #3987ea;
  font-weight: 600;
}
.fixedClass {
  margin-top: 22px;
  overflow: hidden;
  line-height: 22px;
  border-bottom: 1px dashed #ddd;
  padding-bottom: 25px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  .btn {
    display: inline-block;
    width: 68px;
    height: 28px;
    text-align: center;
    line-height: 32px;
    border: 1px solid #3987ea;
    color: #5088FF;
    border-radius: 3px;
    float: right;

width: 52px;
height: 32px;
background: rgba(255,255,255,0.2000);
box-shadow: 0px 2px 4px 0px rgba(80,136,255,0.1500);
border-radius: 4px;
border: 1px solid #5088FF;
font-size: 14px;



  }
  > span {
    cursor: pointer;
  }
}
.close {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
}
/deep/ .el-dialog__body ::-webkit-scrollbar {
  width: 6px; /* 滚动条宽度， width：对应竖滚动条的宽度  height：对应横滚动条的高度*/
  background: #007acc;
}
/deep/.el-loading-parent--relative {
  width: 100%;
  line-height: 40px;
  height: 40px;
}
/deep/ .el-loading-spinner i {
  position: absolute;
  left: 15px;
  top: 10px;
  font-size: 24px;
}
/deep/ .el-loading-spinner .el-loading-text {
  position: absolute;
  left: 48px;
}
/deep/ .el-dialog{
  background: #fff0;
}
/deep/ .h1{
  .el-button--primary{
  background: rgba(52, 57, 81, 0.95);
  box-shadow: 0px 2px 10px 0px rgba(0, 130, 255, 0.1);
  border-radius: 4px;
  }

}
</style>
